import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

const inputCls = "w-full bg-transparent border border-ink/25 px-4 py-3 font-body text-lg text-ink focus:border-ink outline-none";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => { e.preventDefault(); await api.post("/auth/forgot-password", { email }); setSent(true); };
  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="mono-label mb-4">Reset password</p>
      <h1 className="font-heading text-4xl text-ink leading-none">A quiet return</h1>
      {sent ? (
        <p className="font-body text-lg text-ink-secondary mt-8 leading-relaxed" data-testid="forgot-sent">If an account exists for that email, a reset link has been sent. (In this version the link is logged to the server.)</p>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="forgot-form">
          <label className="block"><span className="mono-label block mb-2">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" /></label>
          <button className="btn-solid w-full" data-testid="forgot-submit">Send reset link</button>
        </form>
      )}
      <Link to="/login" className="mono-label underline underline-offset-4 mt-8 inline-block">Back to sign in</Link>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      navigate("/login");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <h1 className="font-heading text-4xl text-ink leading-none">Choose a new password</h1>
      <form onSubmit={submit} className="mt-10 space-y-6" data-testid="reset-form">
        <label className="block"><span className="mono-label block mb-2">New password</span>
          <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" /></label>
        {error && <p className="font-body text-terracotta" data-testid="reset-error">{error}</p>}
        <button className="btn-solid w-full" data-testid="reset-submit">Reset password</button>
      </form>
    </div>
  );
}
